// Returns window.localStorage, unless it fails then return a temp store

function localStorageTest() {
  const test = '_testLs';
  try {
    window.localStorage.setItem(test, test);
    window.localStorage.removeItem(test);
    return true;
  } catch (e) {
    console.devLog.info(
      'window.localStorage non-functional, using in-memory store',
    );
    return false;
  }
}

let store = {};
const altLocalStorage = {};

altLocalStorage.getItem = (key) => store[key];

// eslint-disable-next-line no-return-assign
altLocalStorage.setItem = (key, value) => (store[key] = value);

altLocalStorage.removeItem = (key) => delete store[key];

altLocalStorage.clear = () => {
  store = {};
};

const LocalStorage = localStorageTest() ? window.localStorage : altLocalStorage;

export default LocalStorage;
